export default __webpack_public_path__ + "static/media/upskilling.1e3efc9c.svg";